import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";

const GettingToNepal = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "International Flights",
      icon: "Plane",
      content: "Tribhuvan International Airport (KTM) in Kathmandu is Nepal's sole international airport, serving flights from major cities across Asia, Europe, and the Middle East.",
      items: [
        "Direct flights from: Delhi, Dubai, Doha, Bangkok, Singapore, Kuala Lumpur, Hong Kong, Istanbul",
        "Connecting flights via: Dubai (Emirates), Doha (Qatar Airways), Bangkok (Thai Airways, Buddha Air)",
        "Flight time from major hubs: Delhi ~1.5hrs, Bangkok ~3hrs, Dubai ~4hrs, Istanbul ~6hrs",
        "Airlines: Nepal Airlines, Buddha Air, Qatar Airways, Emirates, Thai Airways, Turkish Airlines"
      ]
    },
    {
      title: "Airport Information",
      icon: "Building",
      content: "Tribhuvan International Airport is located about 5km from central Kathmandu. The airport has one international terminal with basic facilities.",
      items: [
        "Visa on arrival counter available 24/7",
        "Currency exchange counters and ATMs in arrival hall",
        "Taxi counter for pre-paid taxis to city center",
        "SIM card counters (Ncell, Nepal Telecom)",
        "Free WiFi available in terminal",
        "Travel time to Thamel district: 20-40 minutes"
      ]
    },
    {
      title: "Land Border Crossings",
      icon: "Map",
      content: "Nepal shares borders with India and China (Tibet). Overland entry is possible from India through several border crossings.",
      items: [
        "Sunuali (Bhairahawa) - most popular, connects to Lumbini",
        "Raxaul (Birgunj) - connects to Kathmandu via highway",
        "Kakarbhitta - eastern entry point from India",
        "Mahendranagar / Dhangadhi - far western entry points",
        "Kodari (Tibet border) - for travel from China (requires special permits)",
        "Indian nationals: no visa required for Nepal"
      ]
    },
    {
      title: "Domestic Travel",
      icon: "Navigation",
      content: "Getting around Nepal involves a combination of domestic flights, buses, and private vehicles. Roads in mountainous areas can be challenging.",
      items: [
        "Domestic flights: Kathmandu to Lukla, Pokhara, Bharatpur, Nepalgunj, Bhairahawa, Biratnagar",
        "Tourist buses: Overnight and day buses connect major cities (Kathmandu-Pokhara ~7hrs)",
        "Private jeep/car: Available for hire with driver",
        "Local buses: Cheapest option but basic comfort",
        "Flights to Lukla: Multiple daily flights from Kathmandu (35 minutes)"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1600&h=600&fit=crop)" }}>
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/70 to-gray-900/50" />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="section-heading text-white mb-4">Getting to Nepal</h1>
              <p className="text-lg text-white/80">How to reach Nepal by air or overland, and how to get around once you arrive.</p>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
            {sections.map((section, i) => (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 lg:p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center">
                    <Icon name={section.icon} size={18} className="text-accent" />
                  </div>
                  <h2 className="font-headline text-xl text-gray-900" style={{ fontWeight: 300 }}>{section.title}</h2>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4">{section.content}</p>
                <ul className="space-y-2">
                  {section.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                      <Icon name="ArrowRight" size={14} className="text-accent mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </main>

      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 text-center text-sm text-white/50">
          &copy; {new Date().getFullYear()} Sherpa Trekker. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default GettingToNepal;
